import { SingleLineTextHelper } from './SingleLineText';
export class PhoneNumberHelper extends SingleLineTextHelper {
    constructor() {
        super(...arguments);
        this.columnDefaultMeta = {};
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvbmVOdW1iZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbHVtbkhlbHBlci9jb2x1bW5zL1Bob25lTnVtYmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBRXhELE1BQU0sT0FBTyxpQkFBa0IsU0FBUSxvQkFBb0I7SUFBM0Q7O1FBQ0Usc0JBQWlCLEdBQUcsRUFBRSxDQUFDO0lBQ3pCLENBQUM7Q0FBQSJ9